import React, { useContext } from 'react';
import isEmpty from 'lodash/isEmpty';

import ChevronLeftIcon from '@ad-scripts/presentation/components/common/icons/stroke/chevron-left-stroke';
import ChevronRightIcon from '@ad-scripts/presentation/components/common/icons/stroke/chevron-right-stroke';
import { InteractiveIconContainer } from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import { SidePanelContext } from 'src/presentation/components/pages/ivr/IvrEditor';

const NodeNavigation = () => {
  const {
    currentNodeNavigationHistoryIndex,
    nodeNavigationHistory,
    onNodeSelected,
    setCurrentNodeNavigationHistoryIndex,
  } = useContext(SidePanelContext);

  const disableGoToPreviousNode = isEmpty(nodeNavigationHistory) || currentNodeNavigationHistoryIndex === 0;
  const disableGoToNextNode =
    currentNodeNavigationHistoryIndex >= nodeNavigationHistory.length - 1 || nodeNavigationHistory.length <= 1;

  const goToPreviousNodeInHistory = () => {
    if (!disableGoToPreviousNode) {
      const newHistoryIndex = currentNodeNavigationHistoryIndex - 1;
      onNodeSelected(nodeNavigationHistory[newHistoryIndex], { doNotUpdateHistory: true });
      setCurrentNodeNavigationHistoryIndex(newHistoryIndex);
    }
  };

  const goToNextNodeInHistory = () => {
    if (!disableGoToNextNode) {
      const newHistoryIndex = currentNodeNavigationHistoryIndex + 1;
      onNodeSelected(nodeNavigationHistory[newHistoryIndex], { doNotUpdateHistory: true });
      setCurrentNodeNavigationHistoryIndex(newHistoryIndex);
    }
  };

  return (
    <>
      <InteractiveIconContainer
        data-aid="previousNodeNavigateControl"
        disabled={disableGoToPreviousNode}
        onClick={goToPreviousNodeInHistory}
      >
        <ChevronLeftIcon />
      </InteractiveIconContainer>
      <InteractiveIconContainer
        data-aid="nextNodeNavigateControl"
        disabled={disableGoToNextNode}
        onClick={goToNextNodeInHistory}
      >
        <ChevronRightIcon />
      </InteractiveIconContainer>
    </>
  );
};

export default NodeNavigation;
